export const trackListingAddCart = (listing) => {
  window.sendFBEvent("AddToCart", {
    value: listing.total.dollars,
    currency: "AUD",
    content_ids: [`${listing.id}`],
    content_type: "product",
    product_catalogue_id: 1031605340269583,
  })
}
